import { Module } from 'vuex'
import getters from './getters'
import mutations from './mutations'
import actions from './actions'

import { IUserState } from './types'

export const state = {} as IUserState

const User: Module<IUserState, any> = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}

export default User
